import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { Customer } from 'src/features/customers/utils/types';
import { CustomerFormSchemaValues } from 'src/features/customers/utils/formSchema';

const RESOURCE = '/customers/customer/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends CustomerFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<Customer> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateCustomer };
